var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "SSID"
    },
    model: {
      value: _vm.ssid,
      callback: function ($$v) {
        _vm.ssid = $$v;
      },
      expression: "ssid"
    }
  })], 1), _c('v-col', [_c('v-select', {
    attrs: {
      "dense": "",
      "outlined": "",
      "items": ['infrastructure', 'ap'],
      "label": _vm.$t('Wireless Mode'),
      "persistent-hint": "",
      "hint": _vm.$t('infrastructure -> wifi client, ap -> access point')
    },
    on: {
      "input": function ($event) {
        return _vm.update('type', $event.target.value);
      }
    },
    model: {
      value: _vm.value.mode,
      callback: function ($$v) {
        _vm.$set(_vm.value, "mode", $$v);
      },
      expression: "value.mode"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }